/**
 * @voltxampere/ui — BC547 NPN BJT variant (Sprint 38-1)
 *
 * Reference: TI BC547 spec (TO-92 general-purpose NPN, EU favourite).
 *   Is = 1.0e-14 A
 *   Bf = 300 (high-gain B group; A=110, B=200, C=420 sub-bins)
 *   Vaf = 80 V
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const bjtNpnBc547 = {
    id: "bc547",
    nameTr: "BC547 (NPN, TO92)",
    nameEn: "BC547 (NPN, TO92)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "BC547",
    schemaType: "bjt-npn",
    defaultParams: { Is: 1.0e-14, Bf: 300, Vaf: 80 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=bjt-npn-bc547.js.map